import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { findValidI18nKey } from 'pricing-pages-lib/utils/languageUtils';
const IconWrapper = styled.span.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "FeatureTableUserIcon__IconWrapper",
  componentId: "rqegt4-0"
})([""]);

const FeatureTableUserIcon = ({
  freeUserAccess,
  productLine,
  showTooltip = true
}) => {
  const isUngatedForSeats = useSelector(isUngatedForSeatsSelector);
  const tooltipKey = isUngatedForSeats ? findValidI18nKey([`featureTable.freeUserSeats.${freeUserAccess}.${productLine}`, `featureTable.freeUserSeats.${freeUserAccess}.default`]) : `featureTable.freeUser.${freeUserAccess}`;
  return /*#__PURE__*/_jsx("p", {
    className: "m-all-0",
    children: /*#__PURE__*/_jsx(UITooltip, {
      disabled: !showTooltip,
      placement: "top",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: tooltipKey
      }),
      children: /*#__PURE__*/_jsx(IconWrapper, {
        children: /*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-1",
          name: "contacts"
        })
      })
    })
  });
};

export default FeatureTableUserIcon;